module.exports = __webpack_public_path__ + "img/proactive.a863a54e.png";